<template>
  <div>
    <div :style="style" @click="handlePage">
      <img
        v-if="config.property_data.icon_url && isEditorStatus === false"
        :style="{ width: config.property_data.width + 'px' }"
        :src="config.property_data.icon_url"
      />
      <span v-else>{{ config.property_data.text }}</span>
      <span v-if="isEditorStatus">(请预览效果)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tms-rule",
  props: ["config", "isEditorStatus"],
  computed: {
    style() {
      const positions = {};
      const { right, top } = this.config.property_data;
      positions.top = top + "px";
      positions.right = right + "px";
      if (this.isEditorStatus === false) {
        positions.position = "fixed";
      } else {
        positions.position = "unset";
      }
      return {
        "z-index": 99,
        ...positions,
      };
    },
  },
  methods: {
    handlePage() {
      if (this.isEditorStatus === false && this.config.property_data.url) {
        let url = this.config.property_data.url;
        if (/^(https|http):\/\//.test(url) === false) {
          url = "https://" + url;
        }
        window.location.href = url;
      }
    },
  },
};
</script>
